import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class SpotApi extends BaseApi {
  async getSpotById(
    parameters: APIPaths["/operator-dash/spot/{id}"]["get"]["parameters"]["path"],
  ): Promise<APIPaths["/operator-dash/spot/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/operator-dash/spot/${parameters.id}`)).data;
  }
  async getSpotList(
    parameters: APIPaths["/operator-dash/spot/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/operator-dash/spot/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/operator-dash/spot/list", { params: parameters })).data;
  }
}
